import { LoadingSpinner } from './loading';

const PageLoader = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <LoadingSpinner size="lg" />
        <p className="text-muted-foreground text-sm animate-pulse">Chargement...</p>
      </div>
    </div>
  );
};

export default PageLoader;